/**@internal */
export var CustomAction;
(function (CustomAction) {
    CustomAction[CustomAction["RequestAppId"] = 17] = "RequestAppId";
})(CustomAction || (CustomAction = {}));
//# sourceMappingURL=actions.js.map